import { SettingsEndpoint } from "@constants/ApiEndpoints";
import { AxiosInstance } from "axios";
import { PackageModel } from "models/Settings/RevenuManagement/PackageModel";
import { FetchingRequestParamsModels } from "models/Shared/FetchingRequestParamsModels";

export const remove =
  (axios: AxiosInstance) =>
  async (id: number): Promise<PackageModel> => {
    return await axios.delete(
      `${SettingsEndpoint.SETTINGS_REVENU_MANAGEMENT_PACKAGE}/${id}`,
      {
        params: { target: "package" },
      }
    );
  };

export const getAll =
  (axios: AxiosInstance) =>
  async (params?: FetchingRequestParamsModels): Promise<PackageModel[]> => {
    return await axios
      .get(SettingsEndpoint.SETTINGS_REVENU_MANAGEMENT_PACKAGE, {
        params: { ...params, target: "package" },
      })
      .then(({ data }) => data.items);
  };

export const getById =
  (axios: AxiosInstance) =>
  async (id?: number): Promise<PackageModel> => {
    return await axios
      .get(`/${SettingsEndpoint.SETTINGS_REVENU_MANAGEMENT_PACKAGE}/${id}`, {
        params: { target: "package" },
      })
      .then(({ data }) => data);
  };

export const create =
  (axios: AxiosInstance) =>
  async (data: PackageModel): Promise<PackageModel> => {
    return await axios
      .post(SettingsEndpoint.SETTINGS_REVENU_MANAGEMENT_PACKAGE, data, {
        params: { target: "package" },
      })
      .then(({ data }) => data);
  };

export const update =
  (axios: AxiosInstance) =>
  async (data: PackageModel): Promise<PackageModel> => {
    return await axios
      .put(
        `/${SettingsEndpoint.SETTINGS_REVENU_MANAGEMENT_PACKAGE}/${data.id}`,
        data,
        {
          params: { target: "package" },
        }
      )
      .then(({ data }) => data);
  };

export const toggleStatus =
  (axios: AxiosInstance) =>
  async (id: number): Promise<PackageModel> => {
    return await axios
      .patch(`/${SettingsEndpoint.SETTINGS_REVENU_MANAGEMENT_PACKAGE}/${id}`, {
        params: { target: "package" },
      })
      .then(({ data }) => data);
  };
